export default __webpack_public_path__ + "static/media/section2-img2-mob.95f7b0f3.png";